import React, { Component } from 'react';
import classNames from 'classnames';
import './FilterRowStyles.scss';

export default function SessionPage(props) {
  const {
    className,
    children,
  } = props;
  return (
    <div className={classNames('filter-row', className)}>
      <div className="filter-list">
        {children}
      </div>
    </div>
  );
}
